


import React, { useState, useEffect } from 'react';
import {
    Grid,
    Button,
    Box,
    Typography,
} from '@mui/material';
import Routes from '../../../routes';
import { trakrefBlue } from '../../../color_utils';
import Input from '../../Common/InputField';
import CommonModal from '../../Common/CommonModal';
import toast from 'react-hot-toast';

import CodeConvert from '../../../Utils/DropDownConvert';


const ProposalModal = ({ payload, modalOpen, onClose, refreshRequired }) => {
    const [proposedWork, setProposedWork] = useState(null);
    const [terms, setTerms] = useState(null);
    const [laborCost, setLaborCost] = useState(null);
    const [otherCost, setOtherCost] = useState(null);
    const [materialCost, setMaterialCost] = useState(null);

    const [primaryTechError, setPrimaryTechError] = useState(null)


    useEffect(() => {

    }, [modalOpen])



    var Validated = () => {
        //ID and PrimaryTechID are required
        var isValid = true

        return isValid
    }

    var ConfirmProposal = async () => {

        const postConfig = {
            method: "POST",
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
                ID: payload.ID,
                ProposedWork: proposedWork,
                Terms: terms,
                LaborCost: laborCost,
                MaterialCost: materialCost,
                OtherCost: otherCost
            })
        }


        const UpdateResponse = await fetch(Routes.WorkOrder.CreateProposal(), postConfig)

        if (UpdateResponse.status == 200) {
            toast.success('The proposal has been successfully created.', { duration: 6000 });
            onClose()
            refreshRequired()
        }
    }

    return (
        <CommonModal open={modalOpen} close={onClose} header={`Create Proposal #${payload.ID}`} bottom={6}>
            <Grid container sx={{ px: { xs: 1, sm: 10 } }}>
                <Grid item xs={12} lg={12} mb={2} pt={2} align='center'>
                    <Input
                        fullWidth
                        variant="outlined"
                        label="Proposed Work"
                        type={'text'}
                        value={proposedWork}
                        onChange={e => setProposedWork(e.target.value)}
                    />
                </Grid>
                <Grid item xs={12} lg={12} mb={2} pt={2} align='center'>
                    <Input
                        fullWidth
                        variant="outlined"
                        label="Terms"
                        type={'text'}
                        multiline={true}
                        value={terms}
                        onChange={e => setTerms(e.target.value)}
                    />
                </Grid>
                <Grid item xs={12} lg={12} mb={2} pt={2} align='center'>
                    <Input
                        fullWidth
                        variant="outlined"
                        label="Labor Cost"
                        type={'number'}
                        value={laborCost}
                        onChange={e => setLaborCost(e.target.value)}
                    />
                </Grid>
                <Grid item xs={12} lg={12} mb={2} pt={2} align='center'>
                    <Input
                        fullWidth
                        variant="outlined"
                        type={'number'}
                        label="Other Cost"
                        value={otherCost}
                        onChange={e => setOtherCost(e.target.value)}
                    />
                </Grid>
                <Grid item xs={12} lg={12} mb={2} pt={2} align='center'>
                    <Input
                        fullWidth
                        variant="outlined"
                        type={'number'}
                        label="Material Cost"
                        value={materialCost}
                        onChange={e => setMaterialCost(e.target.value)}
                    />
                </Grid>
                <Grid item xs={12} lg={12} mb={2} pt={2} align='left'>
                    <Typography sx={{ padding: '1% 0%', fontSize: 17, fontWeight: 600 }}>
                        Total Cost ($) : ${+parseInt(laborCost || 0) + +parseInt(otherCost || 0) + +parseInt(materialCost | 0)}
                    </Typography>
                </Grid>
                <Grid item xs={12} lg={12} align='center'>
                    <Box mt={2} mb={2} sx={{ width: '100%' }}>
                        <Button
                            fullWidth
                            size='large'
                            variant='contained'
                            onClick={() => ConfirmProposal()}
                            style={{
                                backgroundColor: trakrefBlue
                            }}
                        >
                            <Typography sx={{ padding: '1% 0%', color: '#fff', fontSize: 17, fontWeight: 400 }}>
                                CREATE PROPOSAL
                            </Typography>
                        </Button>
                    </Box>
                </Grid>

            </Grid>
        </CommonModal>
    );
};


export default ProposalModal;
